/**
 * Packages
 */
import { Container, Row, Col } from 'react-bootstrap';

/**
 * Styles
 */
import './index.scss';

/**
 * Visualization component
 */
function Visualization() {
  return (
    <section className='Visualization'>
      <Container>
        <Row>
          <Col sm={{ span: 8, offset: 2 }} className="text-center">
            <p className='Visualization__pretitle'></p>
            <h2 className='Visualization__title'>Protect your money</h2>
            <p className='Visualization__subtitle'>
              Read the investment case and key risk
              <br />
              to make smarter, faster decisions
            </p>
            {/* Images */}
            <div className='Visualization__topology-img'></div>
            <div className='Visualization__watchlists-img'></div>
            <div className='Visualization__nvda-img'></div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Visualization;